<template>
<div class="title">
  <p>{{title}}</p>
</div>
</template>

<script>
export default {
  neme: 'Title',
  props: ['title'],
}
</script>

<style scoped>

.title {
  width: 100vw;
  height: 40px;
  background: #F39939;
  text-align: center;
  margin: 0;
  padding: 20px;
}

.title p {
  color: #fff;
  font-size: 20px;
  line-height: 0;
}

</style>
